
















































































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import PrettyCheck from 'pretty-checkbox-vue/check';
import _ from 'lodash';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';
import CommonFormWithInvoiceEditor from '@/components/Invoice/CommonFormWithInvoiceEditor.vue';
import CommonModalWithInvoiceInfo from '@/components/Invoice/CommonModalWithInvoiceInfo.vue';

import { timeframeMonthToMonth } from '@/utils';
import invoiceListOption from '@/table/invoices/invoiceList';

import getInvoices from '@/gql/invoice/getInvoices.gql';
import deleteInvoice from '@/gql/invoice/deleteInvoice.gql';
import updateInvoice from '@/gql/invoice/updateInvoice.gql';
import updateInvoices from '@/gql/invoice/updateInvoices.gql';
import getInvoiceStats from '@/gql/invoice/getDailyStats.gql';

import useDownloadReport from '@/useDownloadReport';

const Overall = defineComponent({
  components: {
    CommonIconTop,
    CommonModalWithPreset,
    CommonFormWithInvoiceEditor,
    PrettyCheck,
    CommonModalWithInvoiceInfo,
  },
  setup() {
    const infoModal = ref(null);
    const { getPDFReport } = useDownloadReport();
    const toCurrency = (str: string | number) => useFormat.number(str).currency();
    const NOW = useFormat.date().computerShortDate();
    const forceReload = ref(false);

    const filter = reactive({
      status: '',
      filterCode: '',
      filterCodeInput: '',
      filterDateRange: {
        from: undefined,
        to: undefined,
      },
    });
    const invoiceInput = _.debounce(() => {
      filter.filterCode = filter.filterCodeInput;
    }, 500);

    // ==== Use to search User ==== //
    const invoicesVariable = computed(() => {
      const vars: {[key: string]: any} = {
        filterStatus: undefined,
        filterCode: undefined,
        filterDateRange: undefined,
      };
      if (filter.status) {
        vars.filterStatus = filter.status;
      }
      if (filter.filterCode) {
        vars.filterCode = `%${filter.filterCode}%`;
      }
      if (filter.filterDateRange.from) {
        vars.filterDateRange = timeframeMonthToMonth(filter.filterDateRange as any);
      }
      return vars;
    });

    const search: Ref<string> = ref('');
    const getInvoicesResult = (data: any) => ({
      data: data.invoices.data.map((inv: any) => ({
        ...inv,
        allowToEditDiscount: false,
      })),
      paginatorInfo: data.invoices.paginatorInfo,
    });

    const editId = ref(-1);
    const modal = ref(null);
    const editInvoice = () => {
      (modal.value as any).open();
    };
    const close = () => {
      (modal.value as any).close();
    };

    const deleteInvoiceModal = ref(null);
    const deleteInvoiceMutation = useMutation(deleteInvoice, {
      refetchQueries: ['getInvoices'],
    });
    function deleteInvoiceAction(invoiceId: number) {
      deleteInvoiceMutation.mutate({
        id: invoiceId,
      });
    }

    // Use to update Invoice status
    const confirmModal = ref(null);
    const pendingUpdateInvoice = reactive({
      id: -1,
      status: 'PENDING',
      date: undefined,
    });
    const updateInvoiceStatusMutation = useMutation(updateInvoice, () => ({
      variables: {
        input: pendingUpdateInvoice,
      },
      refetchQueries: ['getInvoices'],
    }));
    updateInvoiceStatusMutation.onDone(() => {
      (confirmModal.value as any).compose({ action: 'บันทึก', entity: 'สำเร็จ' });
      pendingUpdateInvoice.id = -1;
    });
    function updateInvoiceStatusHandler(id: number, status: string) {
      pendingUpdateInvoice.id = id;
      pendingUpdateInvoice.status = status;
      if (status === 'PAID') pendingUpdateInvoice.date = NOW;
      else pendingUpdateInvoice.date = undefined;
      updateInvoiceStatusMutation.mutate();
    }

    const selectedItemId: number[] = reactive([]);
    function selectItem(id: number | string, invoice: { code: string }) {
      const hitIndex = selectedItemId.indexOf(parseInt(id as string, 10));
      if (hitIndex > -1) {
        selectedItemId.splice(hitIndex, 1);
      } else {
        selectedItemId.push(parseInt(id as string, 10));
      }
    }

    const clearDeliveries = () => {
      forceReload.value = false;
      editId.value = -1;
      selectedItemId.splice(0);
      forceReload.value = true;
    };

    const updateInvoiceBatchMutation = useMutation(updateInvoices, () => ({ refetchQueries: ['getInvoice', 'getInvoices'] }));
    function updateInvoiceBatch(status: string) {
      updateInvoiceBatchMutation.mutate({
        ids: selectedItemId,
        status,
      });
    }
    updateInvoiceBatchMutation.onDone(() => {
      clearDeliveries();
    });

    const { result: invoiceStatsResult, loading } = useQuery(getInvoiceStats);
    const invoiceStats = useResult(invoiceStatsResult, { total: 0 }, (data: any) => data.invoiceStats);

    return {
      toCurrency,
      infoModal,

      search,

      editId,
      modal,
      close,
      editInvoice,

      invoiceListOption,
      getInvoices,
      getInvoicesResult,
      invoicesVariable,
      filter,
      invoiceInput,

      deleteInvoiceModal,
      deleteInvoiceAction,

      selectedItemId,
      selectItem,
      clearDeliveries,
      updateInvoiceBatch,

      // Use to update Invoice status
      confirmModal,
      updateInvoiceStatusHandler,

      // To get report
      getPDFReport,

      invoiceStats,
    };
  },
});

export default Overall;
